import styled from 'styled-components'

export const GalleryWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  max-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 23px;
  opacity: 0;
  transform: translateX(50px);

  &.fade-in {
    animation: fade-in-x50 0.5s ease forwards;
  }

  &.fade-out {
    animation: fade-out-x50 0.5s ease forwards;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.deviceW.sm}) and (max-height: ${({
      theme,
    }) => theme.breakpoints.deviceH.sm}) {
    width: calc(100vw - 82px);
    padding-left: 8px;
    padding-right: 90px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.sm}) {
    flex-direction: row;
    left: 0;
    width: 100vw;
    min-height: 100vh;
    min-height: -webkit-fill-available;
    padding-left: 172px;
    overflow-x: auto;
    overflow-y: hidden;
    gap: 46px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.xxl}) {
    padding-left: 10vw;
  }
`

export const Container = styled.div`
  height: 100%;
  font-size: 12px;
  width: 100%;
  margin: 0 0 100px 0;

  .wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    opacity: 0;
    transform: translateY(30px);
    gap: 30px;
    align-items: start;
    background: ${({ theme }) => theme.colors.white};
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.2);
    border-radius: 24px;
    padding: 64px 32px 32px 32px;

    &.fade-in {
      animation: fade-in-y30 0.3s 0.3s ease forwards;
    }

    &.fade-out {
      animation: fade-out-y30 0.3s ease forwards;
    }

    .about-gallery {
      .title {
        color: ${({ theme }) => theme.colors.grey40};
        font-family: ${({ theme }) => theme.font.light};
        font-size: 28px;
        letter-spacing: 0.35px;
        line-height: 1.375;
      }

      .subtitle {
        color: ${({ theme }) => theme.colors.grey40};
        font-family: ${({ theme }) => theme.font.light};
        font-size: 21px;
        letter-spacing: 0.29px;
        line-height: 1.5;
        margin-bottom: 0.6rem;
      }

      .description {
        color: ${({ theme }) => theme.colors.grey40};
        font-family: ${({ theme }) => theme.font.light};
        font-size: 16px;
        letter-spacing: 0.38px;
        line-height: 1.375;
        margin-bottom: 1.375rem;
      }
    }

    .generated-pattern-container {
      display: flex;
      flex-direction: inherit;

      .generated-pattern {
        width: 100%;
      }
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.deviceW.sm}) {
      .generated-pattern-container {
        justify-content: center;
        align-items: center;

        .generated-pattern {
          max-width: 100%;
          width: auto;
          height: auto;
        }
      }
    }

    .text-container {
      color: rgba(0, 0, 0, 0.49);
      font-size: 16px;
      letter-spacing: 0.38px;
      line-height: 1.5;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.sm}) {
    min-height: calc(100vh - 2 * 10vh);
    font-size: 14px;

    .wrapper {
      flex-direction: row;
    }
  }

  @media (min-height: ${({ theme }) => theme.breakpoints.deviceH.sm}) {
    font-size: 12px;
  }

  @media (min-height: ${({ theme }) => theme.breakpoints.deviceH.sm}) {
    font-size: 16px;
    width: unset;
    margin: 0 50px 0 0;

    .wrapper {
      height: 700px;
      padding: 100px 40px 50px 40px;
      gap: 40px;

      .about-gallery {
        width: 500px;

        .title {
          font-size: 32px;
        }
        .subtitle {
          font-size: 24px;
        }
        .description {
          font-size: 18px;
        }
      }

      .generated-pattern-container {
        height: 100%;
        .generated-pattern {
          width: auto;
          height: 100%;
        }
      }

      .text-container {
        font-size: 21px;
        letter-spacing: 0.5px;
      }
    }
  }

  @media (min-height: ${({ theme }) => theme.breakpoints.deviceH.lg}) {
    .wrapper {
      height: 850px;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.xxl}) {
    display: flex;
    align-items: center;
  }
`

export const ButtonWrapper = styled.div`
  position: absolute;
  top: 18px;
  right: 8px;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow-y: hidden;

  svg {
    height: 24px;
    width: 24px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.sm}) {
    top: 0;
    right: 0;
    width: 150px;

    svg {
      height: 30px;
      width: 30px;
    }
  }
`
